import { useState } from "react";
import { Routes, Navigate, Route, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from "react-bootstrap/Container";
import logo from './logo.svg';
import './App.css';
import './styles/modern.css';

import './cstyles.css'


import StDashTopbar from './components/StDashTopbar.js';
import StDashSidebar from './components/StDashSidebar.js';
import StCmsLayout from './components/StCmsLayout.js';
import StDashLanding from "./pages/StDashLanding.js";
import StDashSite from "./pages/StDashSite.js";
import StDashSite2 from "./pages/StDashSite2.js";
import StDashContactForms from "./pages/StDashContactForms.js";
import StCmsBlogEntries from "./pages/StCmsBlogEntries.js";
import StCmsBlogEditor from "./pages/StCmsBlogEditor.js";
import StCmsEntryEditor from "./pages/StCmsEntryEditor.js";
import StCmsBrand from "./pages/StCmsBrand.js";
import StCmsSchemas from "./pages/StCmsSchemas.js";
import StAuthKeys from "./pages/StAuthKeys.js";
import StSubscription from "./pages/StSubscription.js";
import StSiteEditor from "./pages/StSiteEditor.js";
import StAssetLibraries from "./pages/StAssetLibraries.js";
import StSitePreview from "./pages/StSitePreview.js";
import StDashAutomations from "./pages/StDashAutomations.js";
import { getCurSiteId } from './lib/Common_funcs.js';
import { Toaster } from 'react-hot-toast';


function App() {

  const location = useLocation();
  const curSiteId = getCurSiteId();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Check if we're in CMS mode (any /cms/* route)
  const isCmsMode = location.pathname.includes('/cms');

  return (
    <div className="app-layout">
      {!isCmsMode && (
        <StDashSidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
      )}
      <main
        className="app-main"
        style={{ marginLeft: isCmsMode ? 0 : sidebarCollapsed ? '56px' : '240px' }}
      >
        {!isCmsMode && <StDashTopbar />}
        <Routes>
          {/* Non-CMS Routes */}
          <Route path="/home" element={<StDashLanding />} />
          <Route path="/sites" element={<StDashSite2 />} />
          <Route path="/sites1" element={<StDashSite />} />
          <Route path="/asset-libraries" element={<StAssetLibraries />} />
          <Route path="/contactforms" element={<StDashContactForms />} />
          <Route path="/automations" element={<StDashAutomations />} />
          <Route path="/authkeys" element={<StAuthKeys />} />
          <Route path="/subscription" element={<StSubscription />} />
          <Route path="/editor" element={<StSiteEditor />} />
          <Route path="/editor/:templateId" element={<StSiteEditor />} />
          <Route path="/site-preview" element={<StSitePreview />} />

          {/* CMS Routes - wrapped in CMS Layout */}
          <Route path="/:siteId/cms" element={<StCmsLayout />}>
            <Route index element={<Navigate to="schemas" replace />} />
            <Route path="blog" element={<StCmsBlogEntries />} />
            <Route path="blog/new" element={<StCmsEntryEditor />} />
            <Route path="blog/:entryId" element={<StCmsEntryEditor />} />
            <Route path="entries/:schemaId" element={<StCmsBlogEntries />} />
            <Route path="entries/:schemaId/new" element={<StCmsEntryEditor />} />
            <Route path="entries/:schemaId/:entryId" element={<StCmsEntryEditor />} />
            <Route path="brand" element={<StCmsBrand />} />
            <Route path="schemas" element={<StCmsSchemas />} />
          </Route>
          <Route path="/cms" element={<StCmsLayout />}>
            <Route index element={<Navigate to="schemas" replace />} />
            <Route path="blog" element={<StCmsBlogEntries />} />
            <Route path="blog/new" element={<StCmsEntryEditor />} />
            <Route path="blog/:entryId" element={<StCmsEntryEditor />} />
            <Route path="entries/:schemaId" element={<StCmsBlogEntries />} />
            <Route path="entries/:schemaId/new" element={<StCmsEntryEditor />} />
            <Route path="entries/:schemaId/:entryId" element={<StCmsEntryEditor />} />
            <Route path="brand" element={<StCmsBrand />} />
            <Route path="schemas" element={<StCmsSchemas />} />
          </Route>
        </Routes>
        <Toaster position="top-right" />
      </main>
    </div>
  );
}

export default App;
